module.exports = __webpack_public_path__ + "img/album07_26.13e2e0de.jpg";